import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ChatStore, ChatMessageType } from './types';

export const useChatStore = create<ChatStore>()(
  persist(
    set => ({
      chatHistory: [],

      setChatHistory: history => {
        set(state => ({
          chatHistory: typeof history === 'function' ? history(state.chatHistory) : history,
        }));
      },

      clearChatHistory: () => {
        set({ chatHistory: [] });
      },
    }),
    {
      name: 'chat-storage', // localStorage key
      partialize: state => ({ chatHistory: state.chatHistory }), // Only persist chatHistory
    },
  ),
);
